export default __webpack_public_path__ + "static/media/bg.5a1050e2.png";